// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const moment = require('moment');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { findContractFromHash } = require('utilities/movementsHelper');
const { md5 } = require('utilities/hash');

// @constants
const {
    HISTOGRAM_FETCHING,
    HISTOGRAM_SUCCESS,
    HISTOGRAM_FAILURE,
    MOVEMENTS_CATEGORY_FETCHING,
    MOVEMENTS_CATEGORY_SUCCESS,
    MOVEMENTS_CATEGORY_FAILURE,
    HISTOGRAM_COMPARE_FETCHING,
    HISTOGRAM_COMPARE_FAILURE,
    HISTOGRAM_COMPARE_SUCCESS,
    HISTOGRAM_COMPARE_RESET,
    MONTHLY__TOTALIZED__SUCCESS,
    MONTHLY__TOTALIZED__FETCHING,
    MONTHLY__TOTALIZED__FAILURE
} = require('constants/actionTypes');
const { ACCOUNTS, CARDS } = require('constants/aggregator/products')

const completeExpensesWithContractData = (response, immAccounts, immCards) => {
    let values = [];

    response.forEach(item => {
        const contract = findContractFromHash({
            hash: item.contrato,
            typeAccount: item.tipoCuenta,
            accounts: immAccounts.get('byId', immAccounts),
            cards: immCards.get('byId', immCards)
        });

        if (!!contract) {
            values.push(Object.assign({}, item, {
                currency: contract.balance ? contract.balance.currency : 'EUR',
                contract: contract.iban || contract.number,
                contractId: contract.accountId || contract.cardId || contract.id,
                description: contract.description || contract.alias
            }));
        }
    });

    return values.length > 0 ? values : response;
}

const requestHistogramFetching = () => {
    return {
        type: HISTOGRAM_FETCHING
    };
}

const requestHistogramSuccess = (response, filters) => {
    return {
        type: HISTOGRAM_SUCCESS,
        payload: {
            data: response,
            filters
        }
    };
}

const requestHistogramFailure = () => {
    return {
        type: HISTOGRAM_FAILURE,
    };
}

const requestCategoryMovementsFetching = () => {
    return {
        type: MOVEMENTS_CATEGORY_FETCHING
    };
}

const requestCategoryMovementsSuccess = (response) => {
    return {
        type: MOVEMENTS_CATEGORY_SUCCESS,
        payload: {
            data: response
        }
    };
}

const requestCategoryMovementsFailure = () => {
    return {
        type: MOVEMENTS_CATEGORY_FAILURE,
    };
}



const requestHistogramCompareFetching = () => {
    return {
        type: HISTOGRAM_COMPARE_FETCHING
    };
}

const requestHistogramCompareSuccess = (response, filters) => {
    return {
        type: HISTOGRAM_COMPARE_SUCCESS,
        payload: {
            data: response,
            filters
        }
    };
}

const requestHistogramCompareFailure = () => {
    return {
        type: HISTOGRAM_COMPARE_FAILURE,
    };
}

const resetHistogramCompare = () => {
    return {
        type: HISTOGRAM_COMPARE_RESET
    }
}

const requestMonthlyTotalizedExpenseFetching = () => {
    return {
        type: MONTHLY__TOTALIZED__FETCHING
    };
}

const requestMonthlyTotalizedExpenseSuccess = (response) => {
    return {
        type: MONTHLY__TOTALIZED__SUCCESS,
        payload: {
            data: response
        }
    };
}

const requestMonthlyTotalizedExpenseFailure = () => {
    return {
        type: MONTHLY__TOTALIZED__FAILURE,
    };
}

const requestHistogramCompare = (filters) => (dispatch) => {
    dispatch(requestHistogramCompareFetching());

    const requestData = {
        header:{
            version: 2
        },
        query: {
            temporalGrouping: 'M',
            contracts: filters.contracts,
            from: filters.fromCompareDate,
            to: filters.toCompareDate,
            banks: filters.banks,
            categoriesCodes: filters.categorySelected,
        }
    };

    APIPost(dispatch, apiURLBuilder.getURL('globalExpensesTotalsAll'), requestData)
    .then( response => dispatch(requestHistogramCompareSuccess(response, filters)))
    .catch(error => dispatch(requestHistogramCompareFailure(error)));
}

const requestHistogram = (filters, isPfmAggregatorView = false) => (dispatch) => {

    if(filters.lastYearComparison) {
        dispatch(requestHistogramCompare(filters))
    } else {
        dispatch(resetHistogramCompare())
    }
    const temporalGroupingValueDay = moment(filters.toDate).diff(moment(filters.fromDate), 'months') === 0 && moment(filters.toDate).diff(moment(filters.fromDate), 'days') <= 31;

    const requestData = {
        header:{
            version: 2
        },
        query: {
            temporalGrouping: temporalGroupingValueDay ? 'D' :'M',
            contracts: filters.contracts,
            from: filters.fromDate,
            to: filters.toDate,
            banks: filters.banks,
            categoriesCodes: filters.categorySelected,
        }
    };

    dispatch(requestHistogramFetching());
    isPfmAggregatorView && dispatch(requestMonthlyTotalizedExpenseFetching());

    APIPost(dispatch, apiURLBuilder.getURL('globalExpensesTotalsAll'), requestData)
    .then( response => {
        dispatch(requestHistogramSuccess(response, filters))
        isPfmAggregatorView && dispatch(requestMonthlyTotalizedExpenseSuccess(response.total))
    })
    .catch(error =>{
        dispatch(requestHistogramFailure(error))
        isPfmAggregatorView && dispatch(requestMonthlyTotalizedExpenseFailure())
    });
}

const requestCategoryMovements = (filters, isPfmAggregatorView) => (dispatch, getState) => {
    const immCards = getState().cards;
    const immAccounts = getState().accounts;
    const immAggregatorData = getState().aggregatorData.get('data');

    const requestData = {
        header:{
            version: 2
        },
        query: {
            temporalGrouping: 'M',
            contracts: filters.contracts,
            from: filters.fromDate,
            to: filters.toDate,
            categoryCode: filters.categorySelected,
            banks: filters.banks,
        }
    };

    dispatch(requestCategoryMovementsFetching());

    APIPost(dispatch, apiURLBuilder.getURL('globalExpensesByCategory'), requestData)
    .then( response => {
        const accountList = isPfmAggregatorView ? getAggregatedAccounts(immAggregatorData) : immAccounts;
        const cardList = isPfmAggregatorView ? getAggregatedCards(immAggregatorData) : immCards;
        const movementList = completeExpensesWithContractData(response, accountList, cardList)

        dispatch(requestCategoryMovementsSuccess(movementList))
    }).catch(error => dispatch(requestCategoryMovementsFailure(error)));
}

const getAggregatedAccounts = aggregatorData => {
    const userBankIdList = getUserBankIdList(aggregatorData)
    const accountList = aggregatorData.get('products').filter(product => product.get('product') === ACCOUNTS && userBankIdList.includes(product.get('bank')))

    return accountList.mapKeys(
            (key, account) => md5(account.get('iban', key)
        )
    )
}

const getAggregatedCards = aggregatorData => {
    const userBankIdList = getUserBankIdList(aggregatorData)

    return aggregatorData.get('products').filter(product => product.get('product') == CARDS && userBankIdList.includes(product.get('bank'))).mapKeys((key, card) => md5(card.get('number', key)))
}

const getUserBankIdList = aggregatorData => aggregatorData ? Object.values(aggregatorData.toJS().banks).map(bank => bank.userBankId) : []

module.exports = {
    requestHistogram,
    requestCategoryMovements
}
